(() => {
  const heroes = document.querySelectorAll('.aeya-hero');
  if (!heroes.length) return;

  const getBar = () => {
    const aside = document.querySelector('.aeya-announcement');
    return (aside && aside.closest('.shopify-section')) || aside;
  };

  const apply = () => {
    const bar = getBar();
    const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    heroes.forEach((hero) => {
      hero.style.setProperty('--aeya-announce-h', `${h}px`);
    });
  };

  apply();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(apply);
  }

  const bar = getBar();
  if (bar && 'ResizeObserver' in window) {
    new ResizeObserver(apply).observe(bar);
  }
  window.addEventListener('resize', apply, { passive: true });
  window.addEventListener('orientationchange', apply);
})();
